var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.357 5.255H5.644C4.335 5.255 3.271 6.319 3.271 7.628V16.372C3.271 17.681 4.335 18.745 5.644 18.745H18.356C19.664 18.745 20.728 17.681 20.728 16.372L20.73 7.628C20.73 6.319 19.666 5.255 18.357 5.255ZM19.229 16.372C19.229 16.853 18.837 17.245 18.357 17.245H5.644C5.163 17.245 4.771 16.853 4.771 16.372V7.628C4.771 7.147 5.163 6.755 5.644 6.755H18.357C18.838 6.755 19.23 7.147 19.23 7.628L19.229 16.372Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.356 11.25H6.64398C6.22998 11.25 5.89398 11.586 5.89398 12C5.89398 12.414 6.22998 12.75 6.64398 12.75H17.356C17.77 12.75 18.106 12.414 18.106 12C18.106 11.586 17.771 11.25 17.356 11.25Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.5a5250b84ae8cf03331943da0cec0112.svg";
export { ForwardRef as ReactComponent };